import './index.scss';

import React from 'react';
import CountButton from '../../components/lat-count-button';
import Button from '../../components/button';
import { getCategoryImage } from '../../utils/services';

const CardMeal = props => {
  const {
    theme,
    imageSrc,
    name,
    variants_data,
    select,
    onSelectProduct,
    sectionId,
    index,
    selectedFun,
    isHasSlash,
    actual_price,
    handleIncrement,
    handleDecrement,
    idx,
    extraClass,
    type,
    price,
    handleOnClick,
    quantity,
    entireData,
    setStat,
    count,
    pIndex,
    entire,
    image_url,
    // image_urls,
    entity_id,
    item,
    id,
    variants,
    selectedProduct,
    handleCheckboxChange,
    handleRadioBtnChange
  } = props;
  const image_urls = props?.image_urls;
  // const { name, variants, image_urls, food_type } = item;
  // const { variants_data?.[0]?.price } = variants;
  // const imageUrl = getCategoryImage(image_urls, 'meal');
  let pdpImageUrl = {
    '1x':
      process.env.REACT_APP_API_IMAGE_URL +
      '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg',
    '2x':
      process.env.REACT_APP_API_IMAGE_URL +
      '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg',
    '3x':
      process.env.REACT_APP_API_IMAGE_URL +
      '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
  };

  if (image_urls && image_urls.length) {
    pdpImageUrl = getCategoryImage(image_urls, 'pdpc');
  }

  const renderRadioOrButton = () => {
    if (props?.entire?.button_type === 'is_radio') {
      return (
        <div
          role="presentation"
          className={`card-meal__radio ${
            (type === 'addons'
            ? quantity > 0
            : entity_id === select)
              ? 'card-meal__radio_active delivery'
              : ''
          }`}
        />
      );
    } else if (props?.entire?.button_type === 'is_add_icon') {
      if (props?.entire?.is_allocated && quantity) {
        return (
          <CountButton
            theme={'delivery'}
            {...props}
            index={index}
            pIndex={pIndex}
            handleIncrement={handleIncrement}
            handleDecrement={handleDecrement}
            content={item.quantity}
          />
        );
      } else {
        return (
          <Button
            content="Add"
            theme="delivery"
            size="is-small"
            onClick={() => handleOnClick(item, index, pIndex, entire)}
          />
        );
      }
    } else if (props?.entire?.button_type === 'is_check') {
      return (
        <label className="charity__label d-block">
          <input
            type="checkbox"
            className="charity__checkbox"
            name={item.name}
            id={item.id}
            checked={item.quantity > 0}
            onChange={() => handleCheckboxChange(item.id, item, index, pIndex)}
          />
          <span
            className={`charity__custom delivery ${
              false ? '' : 'charity__custom_uncheck'
            } updated-border`}
          />
        </label>
      );
    } else {
      return (
        <div
          role="presentation"
          className={`card-meal__radio ${
            (type === 'addons'
            ? quantity > 0
            : entity_id === select)
              ? 'card-meal__radio_active delivery'
              : ''
          }`}
        />
      );
    }
  };

  return (
    <div
      className={`container  
      ${
        !props?.entire?.is_allocated &&
        (type === 'addons' ? quantity > 0 : entity_id === select)
          ? `active__index`
          : ''
      } 
      ${props?.entire?.button_type === 'is_radio' &&
        quantity > 0 &&
        `active__index`}
      ${props?.entire?.button_type === 'is_check' &&
        quantity > 0 &&
        'active__index'}
      ${extraClass && extraClass}`}
      role="presentation"
      onClick={() => {
        if (type === 'addons') {
          // To handle addons
          if (props?.entire?.button_type === 'is_check') {
            handleCheckboxChange(item.id, item, index, pIndex);
          } else if (props?.entire?.button_type === 'is_radio') {
            onSelectProduct(sectionId, id, props);
          }
        } else if (type === 'variants') {
          // To Select Variants
          selectedFun(entity_id, props.item);
        }
      }}
    >
      {type === 'variants' ? (
        <picture>
          <source
            srcSet={`${pdpImageUrl['1x']}, ${pdpImageUrl['2x']} 2x, ${pdpImageUrl['3x']} 3x`}
            type="image/jpeg/png"
          />
          <img
            src={
              pdpImageUrl['2x']
                ? `${pdpImageUrl['2x']}`
                : process.env.REACT_APP_API_IMAGE_URL +
                  '/products/AE/ml/1xmlPlaceholder134x67AddonSectionjpg'
            }
            alt={name}
          />
        </picture>
      ) : (
        <picture>
          {image_urls?.[0]?.images?.map(imgData => (
            <source
              key={imgData.name}
              srcSet={`${imgData.image['1x']} 1x, ${imgData.image['2x']} 2x, ${imgData.image['3x']} 3x`}
              type="image/jpeg"
              media={`(max-width: ${
                imgData.name === 'desktop' ? '1200px' : '767px'
              })`}
            />
          ))}
          <img
            src={
              image_urls?.[0]?.images?.find(
                imgData => imgData.name === 'desktop'
              ).image['3x']
            }
            alt="Addon Section"
            style={{
              maxWidth: '101%'
            }}
          />
        </picture>
      )}
      <h2 className="card-meal__name-custom">
        {name.length > 17 ? name.slice(0, 14) + '...' : name}
      </h2>
      <div className="lat-flex">
        {price !== 0 && variants?.price !== 0 && (
          <p className="card-meal__name-custom">
            ₹ {price ? Math.round(price) : Math.round(variants?.price)} /-
          </p>
        )}
        {actual_price && (
          <p className="card-meal__name-custom extra-style">
            {' ' + Math.round(actual_price)}
          </p>
        )}
      </div>
      <div className="radio-button">{renderRadioOrButton()}</div>
    </div>
  );
};

export default CardMeal;
